module.exports = __webpack_public_path__ + "static/media/Inter-Light.4e2e8673.woff2";